import { ReactComponent as IconChevronDown } from '@/assets/svgs/chevron-down.svg'
import { ToastContext } from '@/context/toast/index'
import useEclips from '@/hooks/use-eclips/index'
import usePaginating from '@/hooks/use-paginating/index'
import api from '@/services/api/messages.js'
import moment from 'moment'
import { useContext, useEffect, useState } from 'react'
import usePackages from '@/hooks/use-packages/index.js'

export default function DataElementsList({
	visible,
	selected,
	dataElementId,
	search,
	handleMessageSelection,
}) {

	const { addToastMessage } = useContext(ToastContext)
	const [_loading, setLoading] = useState(false)

	const { receivedMessages, receivedMessagesMeta, getReceivedMessages } = usePackages()

	const {
		itemsPerPage,
		currentPage,
		goToPrev,
		goToNext,
		handleCurrnetInput,
		pageLabel,
	} = usePaginating(
		5,
		receivedMessagesMeta?.total || 0,
		receivedMessagesMeta?.totalPages || 0,
	)


	async function downloadFile(id) {
		setLoading(true)
		const [error, result] = await api.downloadFile(
			{
				id,
			},
			'csv',
			{
				params: {
				includeAttachments: true,
				},
			}
		)
		setLoading(false)

		if (error) {
			return addToastMessage(
				error?.error?.message || 'Unable to download file',
				'error',
			)
		}

		const link = document.createElement('a')
		const path = `data:application/zip;base64,${result}`
		link.href = path
		link.download = 'attachment.zip'
		link.click()
	}

	useEffect(() => {
		if (visible) {
			getReceivedMessages(dataElementId, {
				limit: itemsPerPage,
				page: currentPage,
				search,
			})
			handleMessageSelection('')
		}
	}, [search, visible, currentPage, itemsPerPage])

	return (
		<div className="data-elements-list">
			<span className="data-element__import-list-title">
				Select Single Data Element
			</span>
			<div className="data-element__import-list">
				{receivedMessages?.length > 0 ? (
				<>
					{receivedMessages?.map((item, index) => (
					<div
						className={`data-element__import-list-item tooltip ${item?.messageStoreId === selected ? 'selected' : ''
						}`}
						key={`att-${index}`}
						onClick={() => {
						handleMessageSelection(item?.messageStoreId)
						}}
					>
						<span className="data-element__import-list-item__org-name trim">
						{item?.orgName}
						</span>
						<span className="tooltiptext">{item.orgName}</span>
						<span className="data-element__import-list-item__reference-number trim">
						{item?.referenceId || '-'}
						</span>
						<span className="data-element__import-list-item__date">
						{moment(item?.timestamp).format('DD/MM/YY')}
						</span>
						<span className="data-element__import-list-item__action" onClick={() => downloadFile(item?.messageStoreId)}>
						Download
						</span>
					</div>
					))}
				</>
				) : (
				<div className="data-element__import-empty">No data</div>
				)}
			</div>
			<div className="data-table__table__footer__row">
				<div className="data-table__table__footer__row__left">
					<div className="data-table__table__pagination">
						<input
						className="data-table__table__pagination__page"
						type="number"
						value={currentPage}
						onChange={(e) => handleCurrnetInput(e)}
						min="1"
						max={receivedMessagesMeta?.totalPages}
						/>
						<span className="data-table__table__pagination__page__meta">
						{' '}
						of {receivedMessagesMeta?.totalPages || 1} pages{' '}
						</span>
						<button
						className="data-table__table__pagination__prev"
						onClick={() => goToPrev()}
						disabled={currentPage === 1}
						>
						<IconChevronDown />
						</button>
						<button
						className="data-table__table__pagination__next"
						onClick={() => goToNext()}
						disabled={currentPage === receivedMessagesMeta?.totalPages || receivedMessagesMeta?.totalPages === 0}
						>
						<IconChevronDown />
						</button>
					</div>
				</div>
				<div className="data-table__table__footer__row__right">
					<div className="data-table__table__meta">
						Showing {pageLabel} of {receivedMessagesMeta?.total || 0} entries
					</div>
				</div>
			</div>
		</div>
	)
}
